import { Badge } from '@octopus-do/octopus-storybook'
import type React from 'react'

// Goes into the button's `right` slot. The slot sizes its component as an
// icon through className, so the badge ignores it and keeps its own size.
export const ProBadge: React.FC = () => <Badge type="pro" size="large" />
